module.exports = __webpack_public_path__ + "media/_6_.93c2fbb8.mp3";